import type { IconProps } from './types';

export const HistoryIcon = (props: IconProps) => {
  const {
    size = 18,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <path
        d="M16.125 9C16.125 5.06497 12.935 1.875 9 1.875C6.38156 1.875 4.09292 3.28818 2.85449 5.39453H4.23047L4.35645 5.40723C4.64135 5.46542 4.85547 5.71743 4.85547 6.01953C4.85533 6.32155 4.64132 6.5737 4.35645 6.63184L4.23047 6.64453H1.25C0.904922 6.64453 0.625162 6.36457 0.625 6.01953V3.03809C0.625203 2.69308 0.904947 2.41309 1.25 2.41309C1.59505 2.41309 1.8748 2.69308 1.875 3.03809V4.59766C3.35072 2.2142 5.989 0.625001 9 0.625C13.6254 0.625 17.375 4.37462 17.375 9C17.375 13.6254 13.6254 17.375 9 17.375C5.16273 17.375 1.93005 14.7948 0.938477 11.2754L0.848633 10.9326L0.832031 10.8066C0.823284 10.5162 1.01969 10.2502 1.31348 10.1807C1.60752 10.1112 1.9023 10.2614 2.02441 10.5254L2.06543 10.6445L2.1416 10.9365C2.98518 13.9307 5.73682 16.125 9 16.125C12.935 16.125 16.125 12.9351 16.125 9ZM8.22559 4.23047C8.22575 3.88556 8.50568 3.60568 8.85059 3.60547C9.19566 3.60547 9.47542 3.88543 9.47559 4.23047V8.375H12.4277L12.5537 8.3877C12.8386 8.44592 13.0527 8.69792 13.0527 9C13.0527 9.30208 12.8386 9.55408 12.5537 9.6123L12.4277 9.625H8.85059C8.50558 9.62479 8.22559 9.34505 8.22559 9V4.23047Z"
        fill={color}
      />
    </svg>
  );
};
